import { render } from "./ActivityDumpIcon.vue?vue&type=template&id=0857b28e"
import script from "./ActivityDumpIcon.vue?vue&type=script&lang=js"
export * from "./ActivityDumpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__